import React from "react";
import { Link } from "react-router-dom";

import { app_path } from "config";
import { Icon, Typography } from "@plum-xoxo/admin-dsm";

const KybRestrictionMessage = (props) => {
  const { kybStatus } = props;
  return (
    <div className="mr-8 pt-5">
      {/* {kybStatus === 0 ? (
        <Typography
          component="div"
          color="dark"
          shade="c200"
          className="d-flex align-items-center mt-4px"
        >
          <Icon
            color="dark"
            iconName="Info"
            onClick={() => {}}
            shade="c200"
            size="15"
            className="mr-4"
          />
          <Link to={`/${app_path}/accounts/platform-preferences`}>
            <Typography
              component="span"
              color="primary"
              shade="c02"
              className="cursor-pointer mr-4"
            >
              {" "}
              Verify business details{" "}
            </Typography>{" "}
          </Link>
          to send rewards.
        </Typography>
      ) } : null */}

      {kybStatus === 1 ? (
        <Typography
          component="span"
          color="warning"
          shade="c02"
          className="mt-4px"
        >
          Business verification is being processed.
        </Typography>
      ) : kybStatus === 3 || kybStatus === 5 ? (
        <Typography
          component="span"
          color="dark"
          shade="c200"
          className="d-flex align-items-center mt-4px"
        >
          <Icon
            color="dark"
            iconName="Info"
            onClick={() => {}}
            shade="c200"
            size="15"
            className="mr-4"
          />
          <Link to={`/${app_path}/accounts/platform-preferences`}>
            <Typography
              component="span"
              color="primary"
              shade="c02"
              className="cursor-pointer mr-4"
            >
              {" "}
              Verify business details{" "}
            </Typography>{" "}
          </Link>
          to send rewards.
        </Typography>
      ) : null}
    </div>
  );
};

export default KybRestrictionMessage;
